var render = function render(){var _vm=this,_c=_vm._self._c;return _c('the-main-wrapper',[_c('div',{staticClass:"not-found-page"},[_c('lottie',{attrs:{"options":_vm.errorOptions,"height":300,"width":300},on:{"animCreated":_vm.handleAnimation}}),_c('lottie',{attrs:{"options":_vm.noConnectionsOptions,"height":300,"width":300},on:{"animCreated":_vm.handleAnimation}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }